//v1.0
//AbstractController that controllers can extend to get key functionality
import { Core } from './Core';
import { ModuleManager } from 'core/ModuleManager';

import { DOMHelper } from 'core/DOMHelper';
import { Events } from 'core/events/Events';

export abstract class Controller {
	public id: string;
	public global: boolean = false;
	public containerSelector;
	public DOMIsReady: boolean = false;

	protected container: HTMLElement;
	protected app: Core;
	protected module: ModuleManager;
	protected DOM: DOMHelper;
	protected events: Events;

	constructor(id: string) {
		this.app = Core;
		this.id = id;
		this.DOM = Core.DOM;
		this.module = Core.module;
	}

	//Public
	//--------------------------------------------------------------
	//--------------------------------------------------------------

	//Triggered when the DOM is ready:
	public init(params?: any): void {}
	public DOMReady(): void {}
	public DOMUpdated(): void {}
	public modulesMounted(): void {}
	public resize(): void {}
	public scroll(windowY: number): void {}

	public reset(previouState?, isDeeplink: boolean = false): void {}
	public show(previouState?, isDeeplink: boolean = false): void {}
	public hide(nextState?): void {}

	public tick(delta?: number): void {}
	public pause(direction?: string): void {}
	public unpause(): void {}

	public DOMReadyCore(): void {
		if (this.containerSelector) {
			this.container = document.querySelector(this.containerSelector);
		}
		this.DOMIsReady = true;
		this.DOMReady();
	}

	public destroy(): void {
		this.id = null;
		this.app = null;
		this.module = null;
	}

	public pauseForMenu(direction = 'side') {}

	//Protected
	//--------------------------------------------------------------
	//--------------------------------------------------------------

	//Allows other controllers to get refernces to other controllers
	//Allow any so controllers can just be instance of anything:
	protected get(controllerId: string): Controller | any {
		return Core.controller.get(controllerId);
	}

	protected all(): Array<Controller> | Array<any> {
		return null;
	}
}
